module.exports = __webpack_public_path__ + "static/media/DSCN0344_1.30dcd3b9.jpg";